/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, leftMetric: NonNullable<unknown>, leftValue: NonNullable<unknown>, rightChain: NonNullable<unknown>, rightMetric: NonNullable<unknown>, rightValue: NonNullable<unknown> }} Chain_Page_Compare_Stake_Or_Hashrate_DifferentInputs */



/**
* | output |
* | --- |
* | "{leftChain} {leftMetric} is {leftValue}, while {rightChain} {rightMetric} is {rightValue}" |
*
* @param {Chain_Page_Compare_Stake_Or_Hashrate_DifferentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_stake_or_hashrate_different = /** @type {((inputs: Chain_Page_Compare_Stake_Or_Hashrate_DifferentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Stake_Or_Hashrate_DifferentInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} ${i?.leftMetric} is ${i?.leftValue}, while ${i?.rightChain} ${i?.rightMetric} is ${i?.rightValue}`)
});